module.exports = __webpack_public_path__ + "img/klcx_07.15431f1b.jpg";